import { render, staticRenderFns } from "./RequestTokenCameraDialog.vue?vue&type=template&id=b45ce982&scoped=true"
import script from "./RequestTokenCameraDialog.vue?vue&type=script&lang=js"
export * from "./RequestTokenCameraDialog.vue?vue&type=script&lang=js"
import style0 from "./RequestTokenCameraDialog.vue?vue&type=style&index=0&id=b45ce982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45ce982",
  null
  
)

export default component.exports